window._theme = window._theme || {};
document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.tagName === 'IFRAME') {
                handleIframe(node);
              } else if (node.querySelectorAll) {
                const iframes = node.querySelectorAll('iframe');
                iframes.forEach(handleIframe);
              }
            }
          });
        });
      });
      
      function handleIframe(iframe) {
        if (
          iframe.id === 'li_sync_frame' ||
          iframe.closest('#google-merchantwidget-iframe-wrapper')
        ) {
          if (iframe.complete || iframe.readyState === 'complete') {
            iframe.setAttribute('title', 'Google Store Badge');
            observer.disconnect();
          } else {
            iframe.addEventListener('load', function onLoad() {
              this.setAttribute('title', 'Google Store Badge');
              observer.disconnect();
              iframe.removeEventListener('load', onLoad);
            });
          }
        }
      }
      
      const existingIframe = document.querySelector('#google-merchantwidget-iframe-wrapper iframe');
      if (existingIframe) {
        existingIframe.setAttribute('title', 'Google Store Badge');
        observer.disconnect();
      } else {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
})